export type GesturePoint = { x: number; y: number };

/** Ответ вправо только на сенсоре; вертикальная прокрутка остаётся прокруткой. */
export function isReplySwipe(start: GesturePoint, end: GesturePoint): boolean {
  const dx = end.x - start.x;
  const dy = Math.abs(end.y - start.y);
  return dx >= 60 && dy <= 40 && dx > dy * 2;
}

export function voiceHoldAction(start: GesturePoint, end: GesturePoint): 'hold' | 'lock' | 'cancel' {
  if (end.x - start.x <= -80) return 'cancel';
  if (end.y - start.y <= -60) return 'lock';
  return 'hold';
}

/** Отпускание до выдачи разрешения тоже завершает жест, не оставляя скрытую запись. */
export class VoiceHold {
  private action: 'hold' | 'lock' | 'send' | 'cancel' = 'hold';
  move(action: 'hold' | 'lock' | 'cancel') {
    if (this.action === 'hold') this.action = action;
    return this.action;
  }
  release(cancelled = false) {
    if (cancelled) this.action = 'cancel';
    else if (this.action === 'hold') this.action = 'send';
    return this.action;
  }
  get result() { return this.action; }
}
